import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    usersData: [],
    page: 0, 
    dataLoader: false,
    size: 0,
    total: 0,
    scrollLoaderButton: false,
}

const manageUserSlice = createSlice({
    name: 'manageUser',
    initialState,
    reducers: {
        setusersData(state, action) {
            state.usersData = action?.payload?.pagination 
                ? [...state.usersData, ...action?.payload?.usersData]
                : action?.payload?.usersData
            state.total = action?.payload?.total
            state.totalPages = action?.payload?.totalPages || 0
            state.page = action?.payload?.page || 0     
            state.size = action?.payload?.size
            state.scrollLoaderButton = action?.payload?.scrollLoaderButton
            state.dataLoader = action?.payload?.dataLoader||false     
        },
        setUsersLoader(state,action){
            state.dataLoader = action?.payload
        },
        setManageUsersState(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        setManageUserObject(state, action) {
            return { ...state, ...action?.payload }
        },
        defaultState(state, action) {
            return initialState
        }
    }
})

export const ManageUserActions = manageUserSlice.actions

export default manageUserSlice